<template>
  <el-container class="zhzw-layout"
    :class="{'teacherCenter':!headerShow}">
    <el-header v-show="headerShow">
      <common-header :config="config"></common-header>
      <!-- 头部横向导航 -->
      <ul class="header-nav">
        <li class="menu-btn-back pointer"
          @click="goPortal">
          <i class="el-icon-arrow-left"></i>返回首页
        </li>
        <li v-for="(sys, key) in sysList"
          class="pointer"
          :class="{'active': sys.active}"
          :key="key"
          @click="toggleSys(sys)">{{sys.label}}</li>
      </ul>
      <!-- 汉堡导航 对应9大模块 -->
      <transition name="fade">
        <modules-nav v-show="ModulesMenuShow"
          :menu="modulesMenu"></modules-nav>
      </transition>
    </el-header>
    <el-container class="main">
      <el-aside style="width: auto">
        <aside-nav :tierDisplay="tierDisplay"
          v-show="sideMenuShow"></aside-nav>
      </el-aside>
      <el-container>
        <el-main class="layout-container"
          :class="{'no-breadcrumb': !sideMenuShow}">
          <!-- 面包屑 -->
          <breadcrumb v-show="sideMenuShow"
            :queryHistory="queryHistory"></breadcrumb>
          <keep-alive :include="$store.state.keepAliveRoutes">
            <router-view class="page"></router-view>
          </keep-alive>
        </el-main>
      </el-container>
    </el-container>
    <transition name="fade">
      <div class="dropdown"
        v-show="ModulesMenuShow"
        @click="toggleMenu"></div>
    </transition>
  </el-container>
</template>

<script>
import { mapGetters } from "vuex";
import CommonHeader from "../components/common/CommonHeader.vue";
import ModulesNav from "../components/common/ModulesNav.vue";
import AsideNav from "../components/common/AsideNav.vue";
import Breadcrumb from "../components/common/Breadcrumb.vue";
export default {
  props: {
    queryHistory: {
      default: false
    },
    tierDisplay: {
      default: false
    }
  },
  components: {
    CommonHeader,
    ModulesNav,
    AsideNav,
    Breadcrumb,
  },
  data() {
    return {
      modulesMenu: [],
      ModulesMenuShow: false,
      sideMenuShow: true,
      sysList: [],
      config: this.$config,
      headerShow: true,
    };
  },
  computed: {
    ...mapGetters({
      getSideMenuShow: "getSideMenuShow",
      getModulesMenuShow: "getModulesMenuShow",
      getSysList: 'getSysList',
      getHeaderShow: "getHeaderShow",
    })
  },
  watch: {
    getSideMenuShow(val) {
      this.sideMenuShow = val;
    },
    getModulesMenuShow(val) {
      this.ModulesMenuShow = val;
    },
    getSysList(val) {
      this.sysList = val
    },
    // 切换路由时监听导航渲染
    '$route.path'(val) {
      this.updateActiveRouter()
    },
    getHeaderShow(val) {
      this.headerShow = val;
    },
  },
  // 页面刷新时如果不是首页要加载侧边栏
  mounted() {
    this.sysList = this.getSysList
    // 加载汉堡导航内容
    this.modulesMenu = this.$store.getters.getUserInfo.subserverList || this.modulesMenu
    this.updateActiveRouter()
    if (this.$route.query.return_index_url) {
      sessionStorage.setItem('return_index_url', this.$route.query.return_index_url)
    }
  },
  methods: {
    // 不是第一个路由页面刷新时，更新当前侧边导航及头部横向的选中
    updateActiveRouter() {
      this.sysList.forEach((elem, index) => {
        // 默认置空，再找到当前路由属于哪个父级
        elem.active = false
        // 筛选掉外链类型按钮
        if (elem.children && elem.children.length > 0) {
          this.recursiveRouter(elem, elem.children, index)
        }
      })
    },
    // 递归找到当前路由处于哪个层级下，找到当前路由并高亮(先判断当前路由是不是，如果不是向下找)
    recursiveRouter(elem, elemChildren, index) {
      elem.children.forEach((child) => {
        if (child.path === this.$route.path) {
          this.$store.dispatch('updateRouter', elemChildren)
          this.sysList[index].active = true
        } else if (child.children && child.children.length > 0) {
          this.recursiveRouter(child, elemChildren, index)
        }
      })
    },
    toggleSys(sys) {
      this.$store.state.keepAliveRoutes = []
      // 外部链接点击跳转
      if (sys.url && (!sys.children || sys.children.length === 0)) {
        window.open(sys.url)
      } else {
        // 什么路由都没有，不应该
        if (!sys.children || sys.children.length === 0) {

        } else {
          // 切换当前按钮高亮样式
          this.sysList.forEach(elem => { elem.active = false })
          sys.active = true

          if (!sys.children[0].children || sys.children[0].children.length === 0) {
            this.$router.push('/' + sys.children[0].id)
          } else if (sys.children[0].children && sys.children[0].children.some(s => (s.hideNav === false || !s.hideNav))) {
            // this.$router.push('/' + sys.children[0].id + '/' + sys.children[0].children[0].id)
            let secondChildren = sys.children[0].children[0]
            if (secondChildren.children && secondChildren.children.some(s => (s.hideNav === false || !s.hideNav))) {
              let thirdChildren = secondChildren.children[0]
              if (thirdChildren.children && thirdChildren.children.some(s => (s.hideNav === false || !s.hideNav))) {
                this.$router.push('/' + sys.children[0].id + '/' + secondChildren.id + '/' + thirdChildren.id + '/' + thirdChildren.children[0].id)
              } else {
                this.$router.push('/' + sys.children[0].id + '/' + secondChildren.id + '/' + thirdChildren.id)
              }
            } else {
              this.$router.push('/' + sys.children[0].id + '/' + secondChildren.id)
            }
          } else {
            this.$router.push('/' + sys.children[0].id)
          }
          this.$store.dispatch('updateRouter', sys.children)
        }
      }
    },
    toggleMenu() {
      this.menuActive = !this.menuActive
      this.$store.dispatch('updateModulesMenuShow', this.menuActive)
    },
    goPortal() {
      //判断url或者sessionStorage中是否含有return_index_url参数，存在的话则返回来源地址
      if (this.$route.query.return_index_url) {
        window.location.href = unescape(this.$route.query.return_index_url)
      } else if (sessionStorage.getItem('return_index_url')) {
        window.location.href = unescape(sessionStorage.getItem('return_index_url'))
      } else {
        window.location.href = this.$store.getters.getUserInfo.indexServer.url
      }
    }
  }
};
</script>

<style  lang="scss" scoped>
.zhzw-layout {
  background: #f0f5fe;
  position: absolute;
  top: 0px;
  bottom: 0px;
  width: 100%;
  min-width: 1200px;
  .el-header {
    padding: 0;
    height: auto !important;
  }
  .header-nav {
    height: 48px;
    line-height: 48px;
    width: 100%;
    overflow: hidden;
    color: #fff;
    background: linear-gradient(
      270deg,
      rgba(67, 152, 255, 1) 0%,
      rgba(3, 88, 203, 1) 100%
    );
    .menu-btn,
    .menu-btn-back {
      display: inline-block;
      width: 50px;
      line-height: 48px;
      text-align: center;
      float: left;
      i {
        padding-right: 5px;
      }
    }
    .menu-btn-back {
      width: 100px;
      padding: 0;
    }
    li.active {
      background-color: rgba(0, 24, 71, 0.24);
    }
    > li {
      cursor: pointer;
      display: inline-block;
      padding: 0px 20px;
      &:hover {
        background-color: rgba(0, 24, 71, 0.24);
      }
    }
  }
  .main {
    display: flex;
    position: absolute;
    top: 104px;
    bottom: 0px;
    overflow: hidden;
    z-index: 99;
    height: calc(100% - 104px);
    width: 100%;
    .layout-container {
      padding: 10px;
      height: 100%;
      overflow: hidden;
      padding-right: 0;
    }
    .no-breadcrumb {
      padding: 0;
    }
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  .page {
    height: calc(100% - 32px);
    display: flex;
    flex-direction: column;
  }

  a {
    color: white;
  }
  .dropdown {
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    background-color: rgba(0, 0, 0, 0.2);
    z-index: 99;
  }
}
</style>


// WEBPACK FOOTER //
// ../vue-common-laboratory/src/layout/Index.vue